import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialXingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialXing",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.42 8.28c-.2-.44-.64-.74-1.14-.75H6.21c-.2 0-.39.09-.51.23-.06.09-.09.2-.09.32s.03.23.09.32 2.74 4.72 2.74 4.72l-4.29 7.6c-.06.08-.09.19-.09.3s.04.22.1.3c.11.16.3.27.51.27h4.08c.48-.05.88-.36 1.06-.79s4.35-7.68 4.35-7.68L11.4 8.26h.04Zm15.87-6.27h-4.1c-.48.03-.89.34-1.06.77-8.7 15.44-8.98 15.92-8.98 15.92l5.73 10.53c.2.45.63.76 1.14.77h4.07c.2 0 .38-.1.49-.25q.09-.135.09-.3c0-.165-.04-.22-.1-.3S18.89 18.7 18.89 18.7l8.97-15.82q.09-.135.09-.3c0-.165-.03-.22-.09-.3a.56.56 0 0 0-.47-.27z"
    })
  }));
};